import { c as createSvgIcon } from '../../createSvgIcon-de76dc64.js';
import React from 'react';
import 'tslib';
import '@mui/material/SvgIcon';

var index = createSvgIcon(React.createElement("path", { d: "M6.37 7H17.63C20.04 7 22 9.24 22 12C22 14.76 20.04 17 17.63 17H6.37C3.96 17 2 14.76 2 12C2 9.24 3.96 7 6.37 7ZM6.37 15H17.63C18.91 15 20 13.63 20 12C20 10.37 18.91 9 17.63 9H6.37C5.09 9 4 10.37 4 12C4 13.63 5.09 15 6.37 15Z" }), 'Status');

export { index as default };
